import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/scheduledDeliveriesActions'
import * as api from '../api/scheduledDeliveries'

import { message } from 'antd'

function* fetchOpenRequests(action) {
  try {
    const payload = yield call(api.getOpenRequests)
    yield put({ type: constants.SCHEDULED_DELIVERIES_FETCH_OPEN_REQUESTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULED_DELIVERIES_FETCH_OPEN_REQUESTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchOpenRequests() {
  yield takeLatest(constants.SCHEDULED_DELIVERIES_FETCH_OPEN_REQUESTS.ACTION, fetchOpenRequests)
}

function* addScheduledDelivery(action) {
  try {
    const params = {
      scheduledDate: action.scheduledDate,
      vehicle: action.vehicle,
      driver: action.driver,
      arrayOpenItems: action.arrayOpenItems
    }
    yield call(api.addScheduledDelivery, params)
    yield put({ type: constants.SCHEDULED_DELIVERIES_ADD.SUCCESS })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULED_DELIVERIES_ADD.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddScheduledDelivery() {
  yield takeLatest(constants.SCHEDULED_DELIVERIES_ADD.ACTION, addScheduledDelivery)
}

function* fetchScheduledDeliveries(action) {
  try {
    const payload = yield call(api.getScheduledDeliveries, action.id)
    yield put({ type: constants.SCHEDULED_DELIVERIES_FETCH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULED_DELIVERIES_FETCH.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchScheduledDeliveries() {
  yield takeLatest(constants.SCHEDULED_DELIVERIES_FETCH.ACTION, fetchScheduledDeliveries)
}

function* fetchScheduledDeliveryById(action) {
  try {
    const payload = yield call(api.getScheduledDeliveryById, action.scheduledDeliveryId)
    yield put({ type: constants.SCHEDULED_DELIVERIES_FETCH_BY_ID.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULED_DELIVERIES_FETCH_BY_ID.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchScheduledDeliveryById() {
  yield takeLatest(constants.SCHEDULED_DELIVERIES_FETCH_BY_ID.ACTION, fetchScheduledDeliveryById)
}

function* updateScheduledDelivery(action) {
  try {
    const payload = {
      scheduledDeliveryDetails: action.scheduledDeliveryDetails,
      scheduledDeliveryId: action.scheduledDeliveryId,
      items: action.items
    }
    yield call(api.scheduledDeliveryUpdate, payload)
    yield put({ type: constants.SCHEDULED_DELIVERIES_UPDATE.SUCCESS })
    yield call(fetchScheduledDeliveryById, { scheduledDeliveryId: action.scheduledDeliveryId })
    message.success('Delivery updated with success!')
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    message.error('Problems updating Delivery')
    yield put({
      type: constants.SCHEDULED_DELIVERIES_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* deleteScheduledDelivery(action) {
  try {
    const deleted = yield call(api.deleteScheduledDelivery, action.scheduledDeliveryId)
    yield put({ type: constants.SCHEDULED_DELIVERIES_DELETE.SUCCESS, deleted })
    message.success('Delivery deleted with success!')
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    message.error('Problems deleting Delivery')
    yield put({
      type: constants.SCHEDULED_DELIVERIES_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduledDelivery() {
  yield takeLatest(constants.SCHEDULED_DELIVERIES_UPDATE.ACTION, updateScheduledDelivery)
}

function* watchDeleteScheduledDelivery() {
  yield takeLatest(constants.SCHEDULED_DELIVERIES_DELETE.ACTION, deleteScheduledDelivery)
}

export function* rootSaga() {
  yield all([
    fork(watchFetchOpenRequests),
    fork(watchAddScheduledDelivery),
    fork(watchFetchScheduledDeliveries),
    fork(watchFetchScheduledDeliveryById),
    fork(watchUpdateScheduledDelivery),
    fork(watchDeleteScheduledDelivery)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/scheduledDeliveriesSaga.js